'use client';
import React, { useEffect } from 'react';
import Dropzone, {
  DropzoneHandle,
} from '@/components/Layouts/Default/Dropzone';
import { useGlobalUploadHandler } from '@/features/tool/hooks/useGlobalUploadHandler';
import { useAppDispatch } from '@/hooks/redux';
import { hideSide } from '@/store/slices/sideSlice';
import { addToast } from '@/store/slices/toastSlice';
import {
  INVALID_FILE_FORMAT_TOAST,
  isInvalidFileFormatError,
} from '@/features/tool/constants/uploadErrors';

const UploadListener = () => {
  const dropzoneRef = React.useRef<DropzoneHandle>(null);
  const { handleFiles, intent } = useGlobalUploadHandler();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (dropzoneRef.current && intent) {
      dropzoneRef.current.open();
    }
  }, [intent]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      handleFiles(e.target.files);
      dispatch(hideSide());
    }
  };

  return (
    <div className="hidden">
      <Dropzone
        ref={dropzoneRef}
        status="active"
        variant="default" // Use default variant, we hide it anyway
        fileTypes={intent?.fileTypes || []}
        isMultipleFile={intent?.multiple}
        toolType={intent?.toolType}
        onChange={handleFileChange}
        onError={(error) =>
          dispatch(
            addToast(
              isInvalidFileFormatError(error)
                ? INVALID_FILE_FORMAT_TOAST
                : { text: error }
            )
          )
        }
      />
    </div>
  );
};

export default UploadListener;
